import { Tab, Tabs } from "@mui/material";
import { useTabs } from "../../../actprep-ui/hooks/ui";
import ToDoTemplatesTable from "../../../components/ToDoTemplatesTable";
import { Box, Stack } from "@mui/system";
import layout from "../../../actprep-ui/constants/layout";
import ContentBox from "../../../actprep-ui/components/ContentBox";
import ToDoEventsTable from "../../../components/ToDoEventsTable";

export default function ManageToDoItems() {
  const { currentTab, setCurrentTab } = useTabs(["templates", "events"]);
  return (
    <Box
      sx={{
        my: `${layout.navBarHeight + 1}rem`,
        width: "100%",
      }}
      size={12}
    >
      <ContentBox sx={{ height: "100%" }}>
        <Stack sx={{ height: "100%" }}>
          <Tabs
            value={currentTab}
            onChange={(event, val) => setCurrentTab(val)}
            centered
            sx={{ mb: 1, boxSizing: "border-box" }}
          >
            <Tab label="Items" value={"templates"} />
            <Tab label="Events" value={"events"} />
          </Tabs>
          <Box sx={{ flexGrow: 1 }}>
            {currentTab == "templates" && <ToDoTemplatesTable />}
            {currentTab == "events" && <ToDoEventsTable />}
          </Box>
        </Stack>
      </ContentBox>
    </Box>
  );
}
